// client/src/pages/NotificationsList.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

const WEEK_DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

export default function NotificationsList() {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get('/api/notifications')
      .then(res => setNotifications(res.data.items || []))
      .catch(err => {
        console.error('Failed to load notifications', err);
        setError('Could not load notifications.');
      });
  }, [navigate]);

  const handleDelete = (id) => {
    api
      .delete(`/api/notifications/${id}`)
      .then(() => {
        setNotifications(prev => prev.filter(n => n.id !== id));
      })
      .catch(err => {
        console.error('Delete failed', err);
        setError('Could not delete notification.');
      });
  };

 const renderFrequency = (notif) => {
    // Default to 'daily' if frequency is missing
    const freq = notif.frequency || 'daily';
    return freq.charAt(0).toUpperCase() + freq.slice(1);
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
      <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">Your Scheduled Notifications</h1>
      <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
        {notifications.length} active
      </p>
      {error && <p className="text-sm text-red-600 mb-4">{error}</p>}

      {notifications.length === 0 && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sm:p-12 text-center">
          <p className="text-gray-600">No notifications yet.</p>
        </div>
      )}

      <div className="space-y-3 sm:space-y-4">
        {notifications.map(n => (
          <div key={n.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-4 mb-3">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 break-words">{n.title}</h3>
              <span className="text-sm text-gray-500 italic">{renderFrequency(n)}</span>
            </div>
            <div className="space-y-1 text-sm sm:text-base text-gray-700">
              <div>
                <span className="font-medium">When:</span>{' '}
                {new Date(n.scheduled_time).toLocaleString()}
              </div>
              <div>
                <span className="font-medium">Account:</span> {n.bank_account_name} (****{n.bank_account_mask})
              </div>
              <div>
                <span className="font-medium">Phone:</span> {n.phone_name} ({n.phone_number})
              </div>
            </div>
            <div className="flex gap-2 mt-3 pt-3 border-t border-gray-100">
              <button
                onClick={() => navigate(`/notifications/${n.id}/edit`)}
                className="px-4 py-2 min-h-[44px] text-sm font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg transition-colors"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(n.id)}
                className="px-4 py-2 min-h-[44px] text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row gap-3 mt-6 sm:justify-end">
        <button
          className="w-full sm:w-auto px-6 py-3 min-h-[44px] bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          onClick={() => navigate('/create-notification')}
        >
          Create New Notification
        </button>
        <button
          className="w-full sm:w-auto px-6 py-3 min-h-[44px] bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors"
          onClick={() => navigate('/dashboard')}
        >
          Next
        </button>
      </div>
    </div>
  );
}